// ── Office wall-clock helpers, shared by Snooze (EmailDetail) and Schedule send (composers) ────────
// The name is historical ("bkk" = the first tenant's zone); every helper now runs in the tenant's
// region zone via utils/region.ts, whatever the browser's zone, and stores real moments (ms).
import { tz, zonedParts, zonedWallToMs, msToZonedInput, zonedInputToMs } from './region';

/** Today's date in the tenant's zone + `days`, at hour:minute of that wall clock → the real moment (ms). */
export function bkkAt(days: number, hour: number, minute = 0): number {
  const p = zonedParts();
  return zonedWallToMs(p.y, p.m, p.d + days, hour, minute);
}
/** Day of week (0 = Sunday) and hour right now, in the tenant's zone. */
export const bkkNow = () => { const p = zonedParts(); return { dow: p.dow, hour: p.hh }; };

/** Day, date and time in the interface language, in the tenant's zone; English is UK day-first, e.g. "Fri 25 Sept, 08:00". */
export const fmtBkk = (ms: number, lang: string) => new Date(ms).toLocaleString(lang === 'zh' ? 'zh-CN' : lang === 'th' ? 'th-TH' : 'en-GB',
  { timeZone: tz(), weekday: 'short', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', hourCycle: 'h23' } as Intl.DateTimeFormatOptions);

/** The date-time box works in the tenant's wall clock: 'YYYY-MM-DDTHH:mm' ⇄ the real moment (ms; NaN = incomplete). */
export const toBkkInput = (ms: number) => msToZonedInput(ms);
export const fromBkkInput = (v: string): number => zonedInputToMs(v);
